import * as React from "react";
import { Box } from "@mui/system";
import { Button,Checkbox, Switch,Grid, InputLabel, Select,MenuItem,List,Divider, FormControlLabel, Typography,ButtonGroup,Snackbar ,Alert ,IconButton, Icon,Dialog,DialogTitle,DialogContent,DialogActions,DialogContentText } from "@mui/material";
import {mainThemeStyle} from './components/MainTheme';
import { NestedButtonDropdown } from "./components/header/NestedButtonDropdown";
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { faker } from '@faker-js/faker';
import { format } from 'date-fns';
import { useState,useRef,useEffect } from "react";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import SaveIcon from '@mui/icons-material/Save';
import LoadingButton from '@mui/lab/LoadingButton';
import axios from "./axios";
import useTable from "./components/useTable";
import SvgIcon from "@mui/material/SvgIcon";
import NoImage from './asset/noimage.png';
import Popup from "./components/Popup";
import _ from "lodash";
import moment from 'moment';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { styled } from '@mui/material/styles';
import GlobalAlert from "./GlobalAlert";
import GlobalRoleAccess from "./GlobalRoleAccess";
import GlobalRoleAccessInner from "./GlobalRoleAccessInner";
import useToken from "./useToken";
import TimezoneSelect from 'react-timezone-select'
const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));


function EditProperty ( {idOfProperty,dataOfDealer,RefreshToken,...props}){

  let [dataOfProperty,setDataOfProperty] = useState(idOfProperty);
  const [currentTab, setCurrentTab] = useState(0);
  const { getAlertTitle} = GlobalAlert();
  const [openSnack, setOpenSnack] = React.useState(false);
  const {token} = useToken();
  const [openSnackData, setOpenSnackData] = React.useState("This is Success Data");
  const [severityData, setSeverityData] = React.useState("success");
  const [imageUrl, setImageUrl] = useState( idOfProperty.logo_url != null ? "https://mdvaccess.com/"+idOfProperty.logo_url : NoImage);

  const handleCloseSnack= (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnack(false);
  };
  const [showUpdateButton,setshowUpdateButton] = useState(false);
  const {getRoleAccessVal} = GlobalRoleAccess();
  const {getRoleAccessInnerVal} = GlobalRoleAccessInner();
  const [loading,setLoading] = useState(false);
  const [isVisible,setIsVisibile] = useState(false);
  const onClickTogglePassword = () =>{
    setIsVisibile(!isVisible);
  }
  const [selectedImage, setSelectedImage] = useState(null);
  const setPropertyData = () => {
    setshowUpdateButton(true);
    console.log('data of features '+JSON.stringify(dataOfProperty) );
    setDataOfProperty({
      id:  dataOfProperty.id,
      name: dataOfProperty.name,
      email: dataOfProperty.email,
      password: dataOfProperty.password,
      city: dataOfProperty.city,
      state: dataOfProperty.state,
      zip_code: dataOfProperty.zip_code,
      copmpany: dataOfProperty.copmpany,
      website_url: dataOfProperty.website_url,
      address: dataOfProperty.address,
      address_two: dataOfProperty.address_two,
      sub_id:dataOfProperty.sub_id,
      office: dataOfProperty.office,
      date_purchase: dataOfProperty.date_purchase,
      total_unit: dataOfProperty.total_unit,
      unit_cost: dataOfProperty.unit_cost,
      signup_type: dataOfProperty.signup_type,
      status:  dataOfProperty.status,
      contacts: dataOfProperty.contacts,
      dealer: dataOfProperty.dealer,
      disabled: dataOfProperty.disabled,
      rfid_enabled: dataOfProperty.rfid_enabled,
      rfid_format: dataOfProperty.rfid_format,
      ouath_client: dataOfProperty.ouath_client,
      oauth_secret: dataOfProperty.oauth_secret,
      api_access: dataOfProperty.api_access,
      lpr_accesss: dataOfProperty.lpr_accesss,
      elevator_accesss: dataOfProperty.elevator_accesss,
      brivo_username: dataOfProperty.brivo_username,
      brivo_password: dataOfProperty.brivo_password,
      brivo_clientid: dataOfProperty.brivo_clientid,
      brivo_clientsecret: dataOfProperty.brivo_clientsecret,
      lic_blacklist: dataOfProperty.lic_blacklist,
      g_parking_off: dataOfProperty.g_parking_off,
      custom_field: dataOfProperty.custom_field,
      logo_url: dataOfProperty.logo_url,
      dealer_company_name: dataOfProperty.dealer_company_name,
      image_upload_data: dataOfProperty.image_upload_data,
      issub:token.issub,
      subId:token.subid,
      start_date:dataOfProperty.start_date,
      added_features:dataOfProperty.added_features,
      features:dataOfProperty.features
    });
  }
  const getDisableValue = (val) => {
    if(token.role == 'superadmin' || token.name === 'SUPER ADMIN'){
      if(token.sub_type == "1"){
        let idData ;
        let valOfDisableData = getRoleAccessInnerVal("8");
        for(let i = 0; i < valOfDisableData.length ; i ++){
          if(valOfDisableData[i].access_name == val ){
            idData = i;
            break;
          }
        }
        let valOfDisable = valOfDisableData[idData].administrator_control;
        if(valOfDisable == "1"){
          return false;
        }
        else{
          return true;
        }
      }
      else{
        let idData ;
        let valOfDisableData = getRoleAccessInnerVal("8");
        for(let i = 0; i < valOfDisableData.length ; i ++){
          if(valOfDisableData[i].access_name == val ){
            idData = i;
            break;
          }
        }
        let valOfDisable = valOfDisableData[idData].administrator_sub_control;
        if(valOfDisable == "1"){
          return false;
        }
        else{
          return true;
        }
      }
    }
    else{
      return true;
    }
   
    
  }
  const handleInputChange = (event) =>{
    let ds = event.target.name;
    dataOfProperty[ds] = event.target.value;
    setPropertyData();
  }
  const handlecheckboxCheck =(event) =>{
    let ds = event.target.name;
    dataOfProperty[ds] = event.target.checked == true ? "1" : "0";
    setPropertyData();
  }
  const handlecheckboxCheckReverse =(event) =>{
    let ds = event.target.name;
    dataOfProperty[ds] = event.target.checked == true ? "0" : "1";
    setPropertyData();
  }
  const changeTimeZone  =  (date, timeZone)=> {
    const laDate = moment.utc(date).format();
    //if (typeof date === 'string') {
      const ldated =  new Date(
        new Date(laDate).toLocaleString('en-US', {
          timeZone,
        }),
      );
      const mystr = moment(ldated).format('YYYY-MM-DD');
      return mystr;
   /* }
  
    return new Date(
      date.toLocaleString('en-US', {
        timeZone,
      }),
    );*/
  }
  const handlecheckboxFeatureCheckChange =(event) =>{
    let ds = event.target.name;
    dataOfProperty.features[ds].available = event.target.checked == true ? "1" : "0";
    setPropertyData();
  }
  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }
  const handleUpdateDistributor = () =>{
    if(dataOfProperty.name == ""){
      setOpenSnackData(getAlertTitle('EPNNE'));
      setSeverityData("error");
      setOpenSnack(true);
      setLoading(false);
      return;
    }
    if(dataOfProperty.copmpany == ""){
      setOpenSnackData(getAlertTitle('EPCNNE'));
      setSeverityData("error");
      setOpenSnack(true);
      setLoading(false);
      return;
    }
    if(dataOfProperty.email == ""){
      setOpenSnackData(getAlertTitle('EPENE'));
      setSeverityData("error");
      setOpenSnack(true);
      setLoading(false);
      return;
    }
    if(!isValidEmail(dataOfProperty.email)){
      setOpenSnackData(getAlertTitle('EPENV'));
      setSeverityData("error");
      setOpenSnack(true);
      setLoading(false);
      return;
    }
    if(dataOfProperty.password.length  < 1 ){
      setOpenSnackData(getAlertTitle('EPPNE'));
      setSeverityData("error");
      setOpenSnack(true);
      setLoading(false);
      return;
    }
    updateMyPostData();
  }
  useEffect(() => {
    console.log("readr image calling");
    if (selectedImage) {
      setImageUrl(URL.createObjectURL(selectedImage));
      console.log("sle"+selectedImage.name);
    }
  }, [selectedImage]);
  const updateMyPostData = async () => {
    setLoading(true);
    try {
      const res = await axios.patch("/administrator/propertyowner/"+dataOfProperty.id,dataOfProperty, {headers: { 'Content-Type':  'application/x-www-form-urlencoded; charset=UTF-8' ,
      'token' : token.token,
      'tokenid' : token.email}});
      console.log( res.data);
      setOpenSnackData(getAlertTitle('EPDUS'));
      setSeverityData("success");
      setOpenSnack(true);
      setLoading(false);
      setshowUpdateButton(false);
    } catch (error) {
      console.log(error.response.data);
      setLoading(false);
      setOpenSnackData(getAlertTitle('EPDUF'));
      setSeverityData("error");
      setOpenSnack(true);
      if(error.response.data.message == 'UnAuthorized'){
        RefreshToken();
			}
    }
  };
  const GetDistributorCompany = () => {
    for(let i = 0; i < dataOfDealer.length ; i++){
      if(dataOfDealer[i].del_id == dataOfProperty.dealer){
        return dataOfDealer[i].company_name;
      }
    }

  };
  const handleSetDistributor = (event) => {
   
    for(let i = 0; i < dataOfDealer.length ; i++){
      if(dataOfDealer[i].company_name == event.target.value){
        console.log("evetm "+ event.target.value);
        dataOfProperty.dealer = dataOfDealer[i].del_id;
        dataOfProperty.dealer_company_name = dataOfDealer[i].company_name;
        setPropertyData();
        break;
      }
    }
   
  };
  const MenuProps = {
    PaperProps: {
      style: {
        backgroundColor: "#1E1E1E",
          borderRadius: 0,
          maxHeight:'250px',
          borderRadius: 10,
          padding:0
      },
    },
  };
  const handleTabClick = (val) => {
    setCurrentTab(val);
  }
  return <>
   <Box sx={{position: 'absolute',
           width:'auto',
           height: '280px',
           top:'50px',
           left: '38px',
           display: { xs: "none", md: 'flex' },
           right: '38px',
           flexGrow: 1,
          
           }}>
             {/* <Stack direction="column" spacing={0}> */}
                        <Stack direction="row" spacing={2} >
                  
           <Typography sx={mainThemeStyle.lableContainsBig}>Service Status :</Typography>

<FormControlLabel  sx={ {height:'100px'}} 
        control={<IOSSwitch sx={{ m: 1 }} name="disabled" disabled = {getDisableValue("Service Status")} onChange={handlecheckboxCheckReverse} checked={dataOfProperty.disabled == "1" ? false : true } />}
        label=""
      />
      {dataOfProperty.disabled == '0' && <Typography sx={mainThemeStyle.lableContainsBigGreen}>ENABLED</Typography>}
{dataOfProperty.disabled == '1' && <Typography sx={mainThemeStyle.lableContainsBigRed}>DISABLED</Typography>}
                  </Stack>
                  {/* <FormControlLabel  sx={ {height:'0'}} 
        control={<IOSSwitch sx={{ m: 1 }} name="disabled" onChange={handlecheckboxCheckReverse} checked={dataOfProperty.disabled == "1" ? false : true } />}
        label=""
      /></Stack> */}
                  </Box>
  
                  <Box sx={{position: 'absolute',
           width:'auto',
           height: '100px',
           top:'50px',
           left: '14px',
           display: { xs: "flex", md: 'none' },
           right: '14px',
           flexGrow: 1,
           justifyContent:"center"
          
           }}>
             {/* <Stack direction="column" spacing={0}> */}
                        <Stack direction="row" spacing={2} justifyContent="center">
                  
           <Typography sx={mainThemeStyle.lableContainsBig}>Service Status :</Typography>

<FormControlLabel  sx={ {height:'65px'}} 
        control={<IOSSwitch sx={{ m: 1 }} name="disabled" disabled = {getDisableValue("Service Status")}  onChange={handlecheckboxCheckReverse} checked={dataOfProperty.disabled == "1" ? false : true } />}
        label=""
      />
      {dataOfProperty.disabled == '0' && <Typography sx={mainThemeStyle.lableContainsBigGreen}>ENABLED</Typography>}
{dataOfProperty.disabled == '1' && <Typography sx={mainThemeStyle.lableContainsBigRed}>DISABLED</Typography>}
                  </Stack>
                  {/* <FormControlLabel  sx={ {height:'0'}} 
        control={<IOSSwitch sx={{ m: 1 }} name="disabled" onChange={handlecheckboxCheckReverse} checked={dataOfProperty.disabled == "1" ? false : true } />}
        label=""
      /></Stack> */}
                  </Box>
  <Box sx={mainThemeStyle.boxTopHeader}>
  {(currentTab == 0 && <Stack spacing={2} direction="row">
    <Typography></Typography>
    <Button sx={mainThemeStyle.buttonHeaderGroup} onClick={()=> {handleTabClick(0)}} active>Property Details</Button>
    <Button sx={mainThemeStyle.buttonHeaderGroupInactive} onClick={()=> {handleTabClick(1)}}>Billing Details</Button>
  
  </Stack>)}
  {(currentTab == 1 && <Stack spacing={2} direction="row">
    <Typography></Typography>
    <Button sx={mainThemeStyle.buttonHeaderGroupInactive} onClick={()=> {handleTabClick(0)}} active>Property Details</Button>
    <Button sx={mainThemeStyle.buttonHeaderGroup} onClick={()=> {handleTabClick(1)}}>Billing Details</Button>
   
  </Stack>)}
      
            
</Box>

<Box sx={{position: 'absolute',
           width:'auto',
          
           top:'150px',
           left: '5px',
           display: { xs: "flex", md: "none" },
           right: '5px',
           flexGrow: 1,
          
           }}>
            {(currentTab == 0 && <Grid container spacing={0.5} rowSpacing={0.5} justifyContent="center">
<Grid item >
    <Button sx={mainThemeStyle.buttonHeaderGroupMobile} onClick={()=> {handleTabClick(0)}} active>Property Details</Button>
  </Grid> <Grid item ><Button sx={mainThemeStyle.buttonHeaderGroupInactiveMobile} onClick={()=> {handleTabClick(1)}}>Billing Details</Button>
  </Grid>
  </Grid>)}
  {(currentTab == 1 && <Grid container spacing={0.5} rowSpacing={0.5} justifyContent="center">
<Grid item >
    <Button sx={mainThemeStyle.buttonHeaderGroupInactiveMobile} onClick={()=> {handleTabClick(0)}} active>Property Details</Button>
    </Grid> <Grid item ><Button sx={mainThemeStyle.buttonHeaderGroupMobile} onClick={()=> {handleTabClick(1)}}>Billing Details</Button>
    </Grid>
  </Grid>)}

           </Box>
<Box sx={mainThemeStyle.boxHeaderBelow}>
<div  sx={{
       right: '54px' ,left: '54px',borderRadius:'0px'}}>
               <div style={{ display: 'flex' }}>
               {(currentTab == 0 &&<Typography variant="h6" component="div" style={{  paddingLeft: '16px',paddingTop: '16px',flexGrow: 1,color:'#fff' }}>
                      Edit Property Owner Details
                   </Typography> )}
                   {(currentTab == 1 &&<Typography variant="h6" component="div" style={{  paddingLeft: '16px',paddingTop: '16px',flexGrow: 1,color:'#fff' }}>
                      Edit Property Billing Details
                   </Typography> )}
               </div>
              
           </div>
           <Divider sx={{backgroundColor:'white'}} />
           {(currentTab == 0 &&<> 
           <Box sx={{display: { xs: "none", md: "flex" }}}>
           <Grid container spacing={2} padding= '32px'> 
      <Grid item xs={2.5}>
        <Stack direction="column"  spacing={2}>
        <Typography  sx={mainThemeStyle.popUpLable} height={40}>Name </Typography>
      <Typography  sx={mainThemeStyle.popUpLable} height={40}>Company Name </Typography>
      <Typography  sx={mainThemeStyle.popUpLable} height={40}>Dealer Company</Typography>
      <Typography  sx={mainThemeStyle.popUpLable} height={40}>Address 1 </Typography>
      <Typography  sx={mainThemeStyle.popUpLable} height={40}>Address 2 </Typography>
      <Typography sx={mainThemeStyle.popUpLable} height={40}> City </Typography>
      <Typography sx={mainThemeStyle.popUpLable} height={40}> State </Typography>
      <Typography sx={mainThemeStyle.popUpLable} height={40}> Zip </Typography>
      </Stack>
      </Grid>
      
      <Grid item xs={2.5}>
      <Stack direction="column"  spacing={2}>
         <TextField
       
       type="text"
       name = "name"
       onChange={handleInputChange}
       value={dataOfProperty.name}
       sx={mainThemeStyle.InputMenuItem}
                       InputLabelProps={{ shrink: true }
                     }
                     disabled = {getDisableValue("Name")}
                         variant="filled"
                       InputProps={{
                          
                           sx: {
                               
                               color:'rgba(135, 135, 135, 0.5)',
                               height:'33px',
                               borderRadius: '5px',
                               backgroundColor: '#121212',
                               boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                               padding: '0 0 15px 0',
                               textIndent: '15px !important',
                               '&.Mui-disabled': {
             

                                background: 'rgba(135, 135, 135, 0.5)',
                              },
                              
                              "& input.Mui-disabled": {
                                color: "white"
                              }
                              
                               
                           },
                       }}
                      
     />
         <TextField
      
       type="text"
       name = "copmpany"
       onChange={handleInputChange}
       value={dataOfProperty.copmpany}
       sx={mainThemeStyle.InputMenuItem}
                       InputLabelProps={{ shrink: true }
                     }
                     disabled = {getDisableValue("Company Name")}
                     variant="filled"
                       InputProps={{
                          
                           sx: {
                               
                               color:'rgba(135, 135, 135, 0.5)',
                               height:'33px',
                               borderRadius: '5px',
                               backgroundColor: '#121212',
                               boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                               padding: '0 0 15px 0',
                               textIndent: '15px !important',
                               '&.Mui-disabled': {
             

                                background: 'rgba(135, 135, 135, 0.5)',
                              },
                              
                              "& input.Mui-disabled": {
                                color: "white"
                              }
                              
                               
                           },
                       }}
                      
     />
  <Select
            sx={{ color: 'rgba(135, 135, 135, 0.5)',
            height:'33px',
            marginTop:'4px',
            marginBottom:'3px',
            borderRadius: '5px',
            backgroundColor: '#121212',
            boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
            padding: '5px 0 5px 0',
            "& .MuiSvgIcon-root": {
              color: "rgba(135, 135, 135, 0.5)",
            },
            
            '&.Mui-disabled': {
             

              background: 'rgba(135, 135, 135, 0.5)',
            },
            "& input.Mui-disabled": {
              color: "white"
            }
            }}
            name = "app_unlock_mode"
            disabled = {getDisableValue("Dealer Company")}
            value={GetDistributorCompany()}
          label="Age"
          onChange={handleSetDistributor}
          variant="filled"
          hiddenLabel
          MenuProps={MenuProps}>
            { dataOfDealer.map(menuItem => {
                  
                  return (
                    <MenuItem  sx={
                      {
                      
                      color:"#fff",
                      backgroundColor: "#2F323A",
                      borderBottom: '.5px solid grey',
                      fontFamily: "Lato",fontSize:'12px',
                  }}
                   value={menuItem.company_name}>
                      {menuItem.company_name}
                    </MenuItem>
                  );
                })} 
          </Select>
         <TextField
      
       type="text"
       name = "address"
       onChange={handleInputChange}
       value={dataOfProperty.address}
       sx={mainThemeStyle.InputMenuItem}
                       InputLabelProps={{ shrink: true }
                     }
                     disabled = {getDisableValue("Address 1")}
                     variant="filled"
                       InputProps={{
                          
                           sx: {
                               
                               color:'rgba(135, 135, 135, 0.5)',
                               height:'33px',
                               borderRadius: '5px',
                               backgroundColor: '#121212',
                               boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                               padding: '0 0 15px 0',
                               textIndent: '15px !important',
                               '&.Mui-disabled': {
             

                                background: 'rgba(135, 135, 135, 0.5)',
                              },
                              
                              "& input.Mui-disabled": {
                                color: "white"
                              }
                              
                               
                           },
                       }}
                      
     />
      <TextField
       
       type="text"
       name = "address_two"
       onChange={handleInputChange}
       value={dataOfProperty.address_two}
       sx={mainThemeStyle.InputMenuItem}
                       InputLabelProps={{ shrink: true }
                     }
                     disabled = {getDisableValue("Address 2")}
                     variant="filled"
                       InputProps={{
                          
                           sx: {
                               
                               color:'rgba(135, 135, 135, 0.5)',
                               height:'33px',
                               borderRadius: '5px',
                               backgroundColor: '#121212',
                               boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                               padding: '0 0 15px 0',
                               textIndent: '15px !important',
                               '&.Mui-disabled': {
             

                                background: 'rgba(135, 135, 135, 0.5)',
                              },
                              
                              "& input.Mui-disabled": {
                                color: "white"
                              }
                              
                               
                           },
                       }}
                      
     />
     <TextField
                      
                      height={40}
                      type= 'text'
                      name = "city"
                       onChange={handleInputChange}
                      value={dataOfProperty.city}
                      sx={mainThemeStyle.InputMenuItem}
                      InputLabelProps={{ shrink: true }
                    }
                    disabled = {getDisableValue("City")}
                    variant="filled"
                      InputProps={{
                         
                          sx: {
                              
                              color:'rgba(135, 135, 135, 0.5)',
                              height:'33px',
                              borderRadius: '5px',
                              backgroundColor: '#121212',
                              boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                              padding: '0 0 15px 0',
                              textIndent: '15px !important',
                            
                              '&.Mui-disabled': {
             

                                background: 'rgba(135, 135, 135, 0.5)',
                              },
                              
                              "& input.Mui-disabled": {
                                color: "white"
                              }
                              
                          },
                      }}
                     
                  />
                   <TextField
                       
                       height={40}
                       type= 'text'
                       name = "state"
                       onChange={handleInputChange}
                       value={dataOfProperty.state}
                       sx={mainThemeStyle.InputMenuItem}
                       InputLabelProps={{ shrink: true }
                     }
                     disabled = {getDisableValue("State")}
                     variant="filled"
                       InputProps={{
                          
                           sx: {
                               
                               color:'rgba(135, 135, 135, 0.5)',
                               height:'33px',
                               borderRadius: '5px',
                               backgroundColor: '#121212',
                               boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                               padding: '0 0 15px 0',
                               textIndent: '15px !important',
                             
                               '&.Mui-disabled': {
             

                                background: 'rgba(135, 135, 135, 0.5)',
                              },
                              
                              "& input.Mui-disabled": {
                                color: "white"
                              }
                               
                           },
                       }}
                      
                   />
                   <TextField
                       
                       height={40}
                       type= 'text'
                       name = "zip_code"
                       onChange={handleInputChange}
                       value={dataOfProperty.zip_code}
                       sx={mainThemeStyle.InputMenuItem}
                       InputLabelProps={{ shrink: true }
                     }
                     disabled = {getDisableValue("Zip")}
                     variant="filled"
                       InputProps={{
                          
                           sx: {
                               
                               color:'rgba(135, 135, 135, 0.5)',
                               height:'33px',
                               borderRadius: '5px',
                               backgroundColor: '#121212',
                               boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                               padding: '0 0 15px 0',
                               textIndent: '15px !important',
                               '&.Mui-disabled': {
             

                                background: 'rgba(135, 135, 135, 0.5)',
                              },
                              
                              "& input.Mui-disabled": {
                                color: "white"
                              }
                              
                               
                           },
                       }}
                      
                   />
      </Stack>
      </Grid>
      <Grid item xs={1}>
    
      </Grid>
      <Grid item xs={2.5}>
        <Stack direction="column"  spacing={2}>
        <Typography sx={mainThemeStyle.popUpLable} height={200}>Logo</Typography>
      <Typography sx={mainThemeStyle.popUpLable} height={40}>Cell #</Typography>
      <Typography sx={mainThemeStyle.popUpLable} height={40}>Email</Typography>
      {/* <Typography sx={mainThemeStyle.popUpLable} height={40}>Password</Typography> */}
      <Typography sx={mainThemeStyle.popUpLable} height={40}>Website URL</Typography>
      <Typography sx={mainThemeStyle.popUpLable} height={40}>Customer Since</Typography>
      </Stack>
      </Grid>
      <Grid item xs={2.5}>
      <Stack direction="column"  spacing={2}>
        
      <Stack direction="row" spacing={2} >
        <img  src={imageUrl} height={200} width={200}></img>
        <Button  sx={mainThemeStyle.normalButton} variant="contained" component="label"  disabled = {getDisableValue("Logo")}>Upload <input hidden accept="image/png, image/jpeg" multiple type="file" 
        onChange={ 
          e => {
            if (e.target.files[0].size > 2000000) {
              console.log("File too large");
              return;
            }
            
            var reader = new FileReader();
            reader.readAsDataURL(e.target.files[0]);
        
            reader.onload = () => {
              console.log(reader.result);
              setshowUpdateButton(true);
              setSelectedImage(e.target.files[0]);
              dataOfProperty.image_upload_data = reader.result;
              setPropertyData();
            };
            reader.onerror = error => {
              console.log("Error: ", error);
            };


          
          }
        }/></Button>
        </Stack>
      
                     
        <TextField
           
           height={40}
           type= 'number'
           name = "office"
           onChange={handleInputChange}
           value={dataOfProperty.office}
           sx={mainThemeStyle.InputMenuItem}
           InputLabelProps={{ shrink: true }
         }
         disabled = {getDisableValue("Cell #")}
         variant="filled"
           InputProps={{
              
               sx: {
                   
                   color:'rgba(135, 135, 135, 0.5)',
                   height:'33px',
                   borderRadius: '5px',
                   backgroundColor: '#121212',
                   boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                   padding: '0 0 15px 0',
                   textIndent: '15px !important',
                   '&.Mui-disabled': {
             

                    background: 'rgba(135, 135, 135, 0.5)',
                  },
                  
                  "& input.Mui-disabled": {
                    color: "white"
                  }
                  
                   
               },
           }}
          
       />
        <TextField
           
           height={40}
           type= 'text'
           name = "email"
           onChange={handleInputChange}
           value={dataOfProperty.email}
           sx={mainThemeStyle.InputMenuItem}
           InputLabelProps={{ shrink: true }
         }
         disabled = {getDisableValue("Email")}
         variant="filled"
           InputProps={{
              
               sx: {
                   
                   color:'rgba(135, 135, 135, 0.5)',
                   height:'33px',
                   borderRadius: '5px',
                   backgroundColor: '#121212',
                   boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                   padding: '0 0 15px 0',
                   textIndent: '15px !important',
                   '&.Mui-disabled': {
             

                    background: 'rgba(135, 135, 135, 0.5)',
                  },
                  
                  "& input.Mui-disabled": {
                    color: "white"
                  }
                  
                   
               },
           }}
          
       />
       {/* <TextField
           
           height={40}
           type= {isVisible ? 'text' : 'password'}
           name = "password"
           onChange={handleInputChange}
           value={dataOfProperty.password}
           margin="normal"
           variant = "filled"
           
           InputLabelProps={{
               shrink: true,
               style: {
               '&::placeholder': {
                   textOverflow: 'ellipsis !important',
                   color: 'blue'
                 },
               }
           }}
           
           InputProps={{
              
               style: {
                   
                 color:'rgba(135, 135, 135, 0.5)',
                   height:'33px',
                   borderRadius: '5px',
                   backgroundColor: '#121212',
                   boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                   padding: '0 0 18px 0',
                   textIndent: '15px !important',
                  
                   
               },
               
               endAdornment: (
                   <InputAdornment position="end">
                       <IconButton
                           style={{
                               color:
                               'rgba(135, 135, 135, 0.5)',
                               padding: '18px 5px 0 0',
                           }}
                           aria-label={
                               'visibility token'
                           }
                           onClick={onClickTogglePassword}
                       >
                          
                          {isVisible ? (
                           <VisibilityOff />
                       ) : (
                           <Visibility />
                       )}
                           
                       </IconButton>
                   </InputAdornment>
               ),
           }}
          
       /> */}
        <TextField
           
           height={40}
           type= 'text'
           name = "website_url"
           onChange={handleInputChange}
           value={dataOfProperty.website_url}
           sx={mainThemeStyle.InputMenuItem}
           InputLabelProps={{ shrink: true }
         }
         disabled = {getDisableValue("Website URL")}
         variant="filled"
           InputProps={{
              
               sx: {
                   
                   color:'rgba(135, 135, 135, 0.5)',
                   height:'33px',
                   borderRadius: '5px',
                   backgroundColor: '#121212',
                   boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                   padding: '0 0 15px 0',
                   textIndent: '15px !important',
                 
                   '&.Mui-disabled': {
             

                    background: 'rgba(135, 135, 135, 0.5)',
                  },
                  
                  "& input.Mui-disabled": {
                    color: "white"
                  }
                   
               },
           }}
          
       />
       <TextField
           
           height={40}
           type= 'date'
           name = "start_date"
           onChange={handleInputChange}
           value={changeTimeZone(dataOfProperty.start_date, 'America/New_York')}
           sx={mainThemeStyle.InputMenuItem}
           InputLabelProps={{ shrink: true }
         }
         disabled = {getDisableValue("Website URL")}
         variant="filled"
           InputProps={{
              
               sx: {
                   
                   color:'rgba(135, 135, 135, 0.5)',
                   height:'33px',
                   borderRadius: '5px',
                   backgroundColor: '#121212',
                   boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                   padding: '0 0 15px 0',
                   textIndent: '15px !important',
                 
                   '&.Mui-disabled': {
             

                    background: 'rgba(135, 135, 135, 0.5)',
                  },
                  
                  "& input.Mui-disabled": {
                    color: "white"
                  }
                   
               },
           }}
          
       />
       
</Stack>
      </Grid>
     
      
      </Grid></Box>
      <Box sx={{display: { xs: "flex", md: "none" }}}>
        <Grid container spacing={2} padding= '10px' paddingBottom='32px' paddingTop='32px'> 
      <Grid item xs={5}>
        <Stack direction="column"  spacing={2}>
        <Typography  sx={mainThemeStyle.popUpLable} height={40}>Name </Typography>
      <Typography  sx={mainThemeStyle.popUpLable} height={40}>Company Name </Typography>
      <Typography  sx={mainThemeStyle.popUpLable} height={40}>Dealer Company</Typography>
      <Typography  sx={mainThemeStyle.popUpLable} height={40}>Address 1 </Typography>
      <Typography  sx={mainThemeStyle.popUpLable} height={40}>Address 2 </Typography>
      <Typography sx={mainThemeStyle.popUpLable} height={40}> City </Typography>
      <Typography sx={mainThemeStyle.popUpLable} height={40}> State </Typography>
      <Typography sx={mainThemeStyle.popUpLable} height={40}> Zip </Typography>
      <Typography sx={mainThemeStyle.popUpLable} height={140}>Logo</Typography>
      <Typography sx={mainThemeStyle.popUpLable} height={40}>Cell #</Typography>
      <Typography sx={mainThemeStyle.popUpLable} height={40}>Email</Typography>
      <Typography sx={mainThemeStyle.popUpLable} height={40}>Website URL</Typography>
      <Typography sx={mainThemeStyle.popUpLable} height={40}>Customer Since</Typography>
      </Stack>
      </Grid>
      
      <Grid item xs={7}>
      <Stack direction="column"  spacing={2}>
         <TextField
       
       type="text"
       name = "name"
       onChange={handleInputChange}
       value={dataOfProperty.name}
       sx={mainThemeStyle.InputMenuItem}
                       InputLabelProps={{ shrink: true }
                     }
                     disabled = {getDisableValue("Name")}

                         variant="filled"
                       InputProps={{
                          
                           sx: {
                               
                               color:'rgba(135, 135, 135, 0.5)',
                               height:'33px',
                               borderRadius: '5px',
                               backgroundColor: '#121212',
                               boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                               padding: '0 0 15px 0',
                               textIndent: '15px !important',
                             
                               '&.Mui-disabled': {
             

                                background: 'rgba(135, 135, 135, 0.5)',
                              },
                              
                              "& input.Mui-disabled": {
                                color: "white"
                              }
                               
                           },
                       }}
                      
     />
         <TextField
      
       type="text"
       name = "copmpany"
       onChange={handleInputChange}
       value={dataOfProperty.copmpany}
       sx={mainThemeStyle.InputMenuItem}
                       InputLabelProps={{ shrink: true }
                     }
                     disabled = {getDisableValue("Company Name")}
                     variant="filled"
                       InputProps={{
                          
                           sx: {
                               
                               color:'rgba(135, 135, 135, 0.5)',
                               height:'33px',
                               borderRadius: '5px',
                               backgroundColor: '#121212',
                               boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                               padding: '0 0 15px 0',
                               textIndent: '15px !important',
                               '&.Mui-disabled': {
             

                                background: 'rgba(135, 135, 135, 0.5)',
                              },
                              
                              "& input.Mui-disabled": {
                                color: "white"
                              }
                              
                               
                           },
                       }}
                      
     />
  <Select
            sx={{ color: 'rgba(135, 135, 135, 0.5)',
            height:'33px',
            marginTop:'4px',
            marginBottom:'3px',
            borderRadius: '5px',
            backgroundColor: '#121212',
            boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
            padding: '5px 0 5px 0',
            "& .MuiSvgIcon-root": {
              color: "rgba(135, 135, 135, 0.5)",
            },
            
            '&.Mui-disabled': {
             

              background: 'rgba(135, 135, 135, 0.5)',
            },
            "& input.Mui-disabled": {
              color: "white"
            }
            }}
            name = "app_unlock_mode"
            disabled = {getDisableValue("Dealer Company")}
            value={GetDistributorCompany()}
          label="Age"
          onChange={handleSetDistributor}
          variant="filled"
          hiddenLabel
          MenuProps={MenuProps}>
            { dataOfDealer.map(menuItem => {
                  
                  return (
                    <MenuItem  sx={
                      {
                      
                      color:"#fff",
                      backgroundColor: "#2F323A",
                      borderBottom: '.5px solid grey',
                      fontFamily: "Lato",fontSize:'12px',
                  }}
                   value={menuItem.company_name}>
                      {menuItem.company_name}
                    </MenuItem>
                  );
                })} 
          </Select>
         <TextField
      
       type="text"
       name = "address"
       onChange={handleInputChange}
       value={dataOfProperty.address}
       sx={mainThemeStyle.InputMenuItem}
                       InputLabelProps={{ shrink: true }
                     }
                     disabled = {getDisableValue("Address 1")}
                     variant="filled"
                       InputProps={{
                          
                           sx: {
                               
                               color:'rgba(135, 135, 135, 0.5)',
                               height:'33px',
                               borderRadius: '5px',
                               backgroundColor: '#121212',
                               boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                               padding: '0 0 15px 0',
                               textIndent: '15px !important',
                               '&.Mui-disabled': {
             

                                background: 'rgba(135, 135, 135, 0.5)',
                              },
                              
                              "& input.Mui-disabled": {
                                color: "white"
                              }
                              
                               
                           },
                       }}
                      
     />
      <TextField
       
       type="text"
       name = "address_two"
       onChange={handleInputChange}
       value={dataOfProperty.address_two}
       sx={mainThemeStyle.InputMenuItem}
                       InputLabelProps={{ shrink: true }
                     }
                     disabled = {getDisableValue("Address 2")}
                     variant="filled"
                       InputProps={{
                          
                           sx: {
                               
                               color:'rgba(135, 135, 135, 0.5)',
                               height:'33px',
                               borderRadius: '5px',
                               backgroundColor: '#121212',
                               boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                               padding: '0 0 15px 0',
                               textIndent: '15px !important',
                             
                               '&.Mui-disabled': {
             

                                background: 'rgba(135, 135, 135, 0.5)',
                              },
                              
                              "& input.Mui-disabled": {
                                color: "white"
                              }
                               
                           },
                       }}
                      
     />
     <TextField
                      
                      height={40}
                      type= 'text'
                      name = "city"
                       onChange={handleInputChange}
                      value={dataOfProperty.city}
                      sx={mainThemeStyle.InputMenuItem}
                      InputLabelProps={{ shrink: true }
                    }
                    disabled = {getDisableValue("City")}
                    variant="filled"
                      InputProps={{
                         
                          sx: {
                              
                              color:'rgba(135, 135, 135, 0.5)',
                              height:'33px',
                              borderRadius: '5px',
                              backgroundColor: '#121212',
                              boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                              padding: '0 0 15px 0',
                              textIndent: '15px !important',
                              '&.Mui-disabled': {
             

                                background: 'rgba(135, 135, 135, 0.5)',
                              },
                              
                              "& input.Mui-disabled": {
                                color: "white"
                              }
                             
                              
                          },
                      }}
                     
                  />
                   <TextField
                       
                       height={40}
                       type= 'text'
                       name = "state"
                       onChange={handleInputChange}
                       value={dataOfProperty.state}
                       sx={mainThemeStyle.InputMenuItem}
                       InputLabelProps={{ shrink: true }
                     }
                     disabled = {getDisableValue("State")}
                     variant="filled"
                       InputProps={{
                          
                           sx: {
                               
                               color:'rgba(135, 135, 135, 0.5)',
                               height:'33px',
                               borderRadius: '5px',
                               backgroundColor: '#121212',
                               boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                               padding: '0 0 15px 0',
                               textIndent: '15px !important',
                             
                               '&.Mui-disabled': {
             

                                background: 'rgba(135, 135, 135, 0.5)',
                              },
                              
                              "& input.Mui-disabled": {
                                color: "white"
                              }
                               
                           },
                       }}
                      
                   />
                   <TextField
                       
                       height={40}
                       type= 'text'
                       name = "zip_code"
                       onChange={handleInputChange}
                       value={dataOfProperty.zip_code}
                       sx={mainThemeStyle.InputMenuItem}
                       InputLabelProps={{ shrink: true }
                     }
                     disabled = {getDisableValue("Zip")}
                     variant="filled"
                       InputProps={{
                          
                           sx: {
                               
                               color:'rgba(135, 135, 135, 0.5)',
                               height:'33px',
                               borderRadius: '5px',
                               backgroundColor: '#121212',
                               boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                               padding: '0 0 15px 0',
                               textIndent: '15px !important',
                               '&.Mui-disabled': {
             

                                background: 'rgba(135, 135, 135, 0.5)',
                              },
                              
                              "& input.Mui-disabled": {
                                color: "white"
                              }
                               
                              
                               
                           },
                       }}
                      
                   />

<Stack direction="column" spacing={2} >
        <img  src={imageUrl} height={100} width={100}></img>
        <Button  sx={mainThemeStyle.normalButton} variant="contained" component="label" disabled = {getDisableValue("Logo")}>Upload <input hidden accept="image/png, image/jpeg" multiple type="file" 
        onChange={ 
          e => {
            if (e.target.files[0].size > 2000000) {
              console.log("File too large");
              return;
            }
            
            var reader = new FileReader();
            reader.readAsDataURL(e.target.files[0]);
        
            reader.onload = () => {
              console.log(reader.result);
              setshowUpdateButton(true);
              setSelectedImage(e.target.files[0]);
              dataOfProperty.image_upload_data = reader.result;
              setPropertyData();
            };
            reader.onerror = error => {
              console.log("Error: ", error);
            };


          
          }
        }/></Button>
        </Stack>
      
                     
        <TextField
           
           height={40}
           type= 'number'
           name = "office"
           onChange={handleInputChange}
           value={dataOfProperty.office}
           sx={mainThemeStyle.InputMenuItem}
           InputLabelProps={{ shrink: true }
         }
         disabled = {getDisableValue("Cell #")}
         variant="filled"
           InputProps={{
              
               sx: {
                   
                   color:'rgba(135, 135, 135, 0.5)',
                   height:'33px',
                   borderRadius: '5px',
                   backgroundColor: '#121212',
                   boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                   padding: '0 0 15px 0',
                   textIndent: '15px !important',
                 
                  '&.Mui-disabled': {
                              

                    background: 'rgba(135, 135, 135, 0.5)',
                  },

                  "& input.Mui-disabled": {
                    color: "white"
                  }
                  
                   
               },
           }}
          
       />
        <TextField
           
           height={40}
           type= 'text'
           name = "email"
           onChange={handleInputChange}
           value={dataOfProperty.email}
           sx={mainThemeStyle.InputMenuItem}
           InputLabelProps={{ shrink: true }
         }
         disabled = {getDisableValue("Email")}
         variant="filled"
           InputProps={{
              
               sx: {
                   
                   color:'rgba(135, 135, 135, 0.5)',
                   height:'33px',
                   borderRadius: '5px',
                   backgroundColor: '#121212',
                   boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                   padding: '0 0 15px 0',
                   textIndent: '15px !important',
                 
                   '&.Mui-disabled': {
                              

                    background: 'rgba(135, 135, 135, 0.5)',
                  },

                  "& input.Mui-disabled": {
                    color: "white"
                  }
                   
               },
           }}
          
       />
       
        <TextField
           
           height={40}
           type= 'text'
           name = "website_url"
           onChange={handleInputChange}
           value={dataOfProperty.website_url}
           sx={mainThemeStyle.InputMenuItem}
           InputLabelProps={{ shrink: true }
         }
         disabled = {getDisableValue("Website URL")}
         variant="filled"
           InputProps={{
              
               sx: {
                   
                   color:'rgba(135, 135, 135, 0.5)',
                   height:'33px',
                   borderRadius: '5px',
                   backgroundColor: '#121212',
                   boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                   padding: '0 0 15px 0',
                   textIndent: '15px !important',
                   '&.Mui-disabled': {
                              

                    background: 'rgba(135, 135, 135, 0.5)',
                  },

                  "& input.Mui-disabled": {
                    color: "white"
                  }
                  
                   
               },
           }}
          
       />

<TextField
           
           height={40}
           type= 'date'
           name = "start_date"
           onChange={handleInputChange}
           value={changeTimeZone(dataOfProperty.start_date, 'America/New_York')}
           sx={mainThemeStyle.InputMenuItem}
           InputLabelProps={{ shrink: true }
         }
         disabled = {getDisableValue("Website URL")}
         variant="filled"
           InputProps={{
              
               sx: {
                   
                   color:'rgba(135, 135, 135, 0.5)',
                   height:'33px',
                   borderRadius: '5px',
                   backgroundColor: '#121212',
                   boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                   padding: '0 0 15px 0',
                   textIndent: '15px !important',
                 
                   '&.Mui-disabled': {
             

                    background: 'rgba(135, 135, 135, 0.5)',
                  },
                  
                  "& input.Mui-disabled": {
                    color: "white"
                  }
                   
               },
           }}
          
       />
      </Stack>
      </Grid>
    
     
     
      
      </Grid></Box></>
       )}
      {(currentTab == 1 && <>
        <Box sx={{display: { xs: "none", md: "flex" }}}>
           <Grid container spacing={2} padding= '32px'> 
      <Grid item xs={2.5}>
        <Stack direction="column"  spacing={2}>
        <Typography  sx={mainThemeStyle.popUpLable} height={40}>Unit Cost</Typography>
      <Typography  sx={mainThemeStyle.popUpLable} height={40}>Enable Auth API </Typography>
      <Typography  sx={mainThemeStyle.popUpLable} height={40}>Enable Elevator API </Typography>
      </Stack>
      </Grid>
      
      <Grid item xs={2.5}>
      <Stack direction="column"  spacing={2}>
         <TextField
       
       type="number"
       name = "unit_cost"
       onChange={handleInputChange}
       value={dataOfProperty.unit_cost}
       sx={mainThemeStyle.InputMenuItem}
                       InputLabelProps={{ shrink: true }
                     }
                     disabled = {getDisableValue("Unit Cost")}
                         variant="filled"
                       InputProps={{
                          
                           sx: {
                               
                               color:'rgba(135, 135, 135, 0.5)',
                               height:'33px',
                               borderRadius: '5px',
                               backgroundColor: '#121212',
                               boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                               padding: '0 0 15px 0',
                               textIndent: '15px !important',
                               '&.Mui-disabled': {
             

                                background: 'rgba(135, 135, 135, 0.5)',
                              },
                              
                              "& input.Mui-disabled": {
                                color: "white"
                              }
                              
                               
                           },
                       }}
                      
     />
       <FormControlLabel  sx={ {height:'35px'}} 
        control={<IOSSwitch sx={{ m: 1 }} name="api_access"  disabled = {getDisableValue("Enable Auth API")} onChange={handlecheckboxCheck} checked={dataOfProperty.api_access == "1" ? true : false } />}
        label=""
      />
  <FormControlLabel  sx={ {height:'35px'}} 
        control={<IOSSwitch sx={{ m: 1 }} name="elevator_accesss" disabled = {getDisableValue("Enable Elevator API")} onChange={handlecheckboxCheck} checked={dataOfProperty.elevator_accesss == "1" ? true : false } />}
        label=""
      />
      </Stack>
      </Grid>
      <Grid item xs={1}>
    
      </Grid>
      <Grid item xs={2.5}>
        <Stack direction="column"  spacing={2}>
        
      {/* <Typography sx={mainThemeStyle.popUpLable} height={40}>Total Unit</Typography> */}
      <Typography sx={mainThemeStyle.popUpLable} height={40}>Enable LPR API</Typography>
      
     
      </Stack>
      </Grid>
      <Grid item xs={2.5}>
      <Stack direction="column"  spacing={2}>
        
    
                     
        {/* <TextField
           
           height={40}
           type= 'number'
           name = "total_unit"
           onChange={handleInputChange}
           value={dataOfProperty.total_unit}
           sx={mainThemeStyle.InputMenuItem}
           InputLabelProps={{ shrink: true }
         }
         
         variant="filled"
           InputProps={{
              
               sx: {
                   
                   color:'rgba(135, 135, 135, 0.5)',
                   height:'33px',
                   borderRadius: '5px',
                   backgroundColor: '#121212',
                   boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                   padding: '0 0 15px 0',
                   textIndent: '15px !important',
                 
                  
                   
               },
           }}
          
       /> */}
         <FormControlLabel  sx={ {height:'35px'}} 
        control={<IOSSwitch sx={{ m: 1 }} name="lpr_accesss" disabled = {getDisableValue("Enable LPR API")} onChange={handlecheckboxCheck} checked={dataOfProperty.lpr_accesss == "1" ? true : false } />}
        label=""
      />
       
       
       
</Stack>
      </Grid>
     
      
      </Grid> 
      </Box>
      <Box sx={{display: { xs: "flex", md: "none" }}}>
      <Grid container spacing={2} padding= '10px' paddingBottom='32px' paddingTop='32px'> 
      <Grid item xs={5}>
        <Stack direction="column"  spacing={2}>
        <Typography  sx={mainThemeStyle.popUpLable} height={40}>Unit Cost</Typography>
      <Typography  sx={mainThemeStyle.popUpLable} height={40}>Enable Auth API </Typography>
      <Typography  sx={mainThemeStyle.popUpLable} height={40}>Enable Elevator API </Typography>
      <Typography sx={mainThemeStyle.popUpLable} height={40}>Enable LPR API</Typography>
      </Stack>
      </Grid>
      
      <Grid item xs={7}>
      <Stack direction="column"  spacing={2}>
         <TextField
       
       type="number"
       name = "unit_cost"
       onChange={handleInputChange}
       value={dataOfProperty.unit_cost}
       sx={mainThemeStyle.InputMenuItem}
                       InputLabelProps={{ shrink: true }
                     }
                     disabled = {getDisableValue("Unit Cost")} 
                         variant="filled"
                       InputProps={{
                          
                           sx: {
                               
                               color:'rgba(135, 135, 135, 0.5)',
                               height:'33px',
                               borderRadius: '5px',
                               backgroundColor: '#121212',
                               boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
                               padding: '0 0 15px 0',
                               textIndent: '15px !important',
                               '&.Mui-disabled': {
             

                                background: 'rgba(135, 135, 135, 0.5)',
                              },
                              
                              "& input.Mui-disabled": {
                                color: "white"
                              }
                              
                               
                           },
                       }}
                      
     />
       <FormControlLabel  sx={ {height:'35px'}} 
        control={<IOSSwitch sx={{ m: 1 }} name="api_access" disabled = {getDisableValue("Enable Auth API")} onChange={handlecheckboxCheck} checked={dataOfProperty.api_access == "1" ? true : false } />}
        label=""
      />
  <FormControlLabel  sx={ {height:'35px'}} 
        control={<IOSSwitch sx={{ m: 1 }} name="elevator_accesss"  disabled = {getDisableValue("Enable Elevator API")}  onChange={handlecheckboxCheck} checked={dataOfProperty.elevator_accesss == "1" ? true : false } />}
        label=""
      />
      <FormControlLabel  sx={ {height:'35px'}} 
        control={<IOSSwitch sx={{ m: 1 }} name="lpr_accesss" disabled = {getDisableValue("Enable LPR API")} onChange={handlecheckboxCheck} checked={dataOfProperty.lpr_accesss == "1" ? true : false } />}
        label=""
      />
      </Stack>
      </Grid>
   
      
  
     
      
      </Grid> 
      </Box>
      <div  sx={{
        right: '54px' ,left: '54px',borderRadius:'0px'}}>
                <div style={{ display: 'flex' }}>
                
                    <Typography variant="h6" component="div" style={{  paddingLeft: '16px',paddingTop: '16px',flexGrow: 1,color:'#fff' }}>
                    Extra Features
                    </Typography> 
                </div>
               
            </div>
            <Divider sx={{backgroundColor:'white'}} />
            <Box sx={{display: { xs: "none", md: "flex" }}}>
            <Grid container spacing={2} padding= '32px'> 
            <Grid item xs={2.5} >
            <Stack direction="column"  spacing={2}><Typography></Typography>
            {dataOfProperty.features.map((row) => (
      Math.abs(row.number % 2) == 0 &&
           <Typography sx={mainThemeStyle.popUpLable} height={40}> {row.title} </Typography>
      ))}</Stack></Grid>
        <Grid item xs={2.5}><Stack direction="column"  spacing={2}><Typography></Typography>
        {dataOfProperty.features.map((row) => (
        Math.abs(row.number % 2) == 0 &&
        <FormControlLabel  sx={ {height:'40px'}} 
        control={<IOSSwitch sx={{ m: 1 }} name={row.number} disabled = {getDisableValue("Extra Features")}  onChange={handlecheckboxFeatureCheckChange} checked={row.available == "1" ? true : false } />}
        label=""
      />
      ))}</Stack>
           </Grid>
           <Grid item xs={1}></Grid>
           <Grid item xs={2.5}><Stack direction="column"  spacing={2}><Typography></Typography>
            {dataOfProperty.features.map((row) => (
        Math.abs(row.number % 2) == 1 &&
           <Typography sx={mainThemeStyle.popUpLable} height={40}> {row.title} </Typography>
      ))}</Stack></Grid>
        <Grid item xs={2.5}><Stack direction="column"  spacing={2}><Typography></Typography>
        {dataOfProperty.features.map((row) => (
        Math.abs(row.number % 2) == 1 &&
        <FormControlLabel  sx={ {height:'40px'}} 
        control={<IOSSwitch sx={{ m: 1 }} name={row.number} disabled = {getDisableValue("Extra Features")}  onChange={handlecheckboxFeatureCheckChange} checked={row.available == "1" ? true : false } />}
        label=""
      />
      ))}</Stack>
           </Grid>
            </Grid>
            </Box>
      <Box sx={{display: { xs: "flex", md: "none" }}}>
      <Grid container spacing={2} padding= '10px' paddingBottom='32px' paddingTop='32px'> 
            <Grid item xs={7}>
            <Stack direction="column"  spacing={2}>
              <Typography></Typography>
            {dataOfProperty.features.map((row) => (
     
           <Typography sx={mainThemeStyle.popUpLable} height={40}> {row.title} </Typography>
      ))}</Stack></Grid>
        <Grid item xs={5}><Stack direction="column"  spacing={2}><Typography></Typography>
        {dataOfProperty.features.map((row) => (
       
        <FormControlLabel  sx={ {height:'35px'}} 
        control={<IOSSwitch sx={{ m: 1 }} name={row.number}  disabled = {getDisableValue("Extra Features")} onChange={handlecheckboxFeatureCheckChange} checked={row.available == "1" ? true : false } />}
        label=""
      />
      ))}</Stack>
           </Grid>
           
            </Grid>
      </Box>
            </>
      )}
      {showUpdateButton &&  <Box sx= {mainThemeStyle.boxDown}><LoadingButton
         
         sx={mainThemeStyle.normalButtonRelative}
         loading={loading}
         onClick={handleUpdateDistributor}
         variant="outlined"
         startIcon={<SaveIcon />}
         loadingPosition="start"
       >
         Save Property Owner Details
       </LoadingButton>
    <Typography></Typography>
      </Box>}
</Box>
<Snackbar open={openSnack} autoHideDuration={6000} onClose={handleCloseSnack}>
        <Alert onClose={handleCloseSnack} severity={severityData} sx={{ width: '100%' }}>
          {openSnackData}
        </Alert>
      </Snackbar>

 </> 
          
          
          
          
          ;
};

export default EditProperty;